import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import IconIG from "../assets/images/logo-ig.png";
import IconYT from "../assets/images/logo-yt.png";
import IconEmail from "../assets/images/logo-email.png";
import { getPath } from "../utils/constants";
import { useTranslation } from "react-i18next";

const links = [
  {
    key: "menu-universe",
    sublinks: [
      { key: "book-kembar", path: "siKembarPintar" },
      { key: "book-reja", path: "jejakRejakids", disabled: true },
      { key: "book-bira", path: "bira", disabled: true },
      { key: "book-cimi", path: "adventureOfCimiCimo", disabled: true },
      { key: "book-gani", path: "gani", disabled: true },
    ],
  },
  // {
  //   key: "menu-product",
  //   sublinks: [
  //     { key: "menu-story-book", path: "storyBook" },
  //     { key: "menu-activity-book", path: "activityBook", disabled: true },
  //     { key: "menu-animation", path: "animation", disabled: true },
  //     { key: "menu-merchandise", path: "merchandise", disabled: true },
  //   ],
  // },
  {
    key: "Quick Links",
    sublinks: [
      { key: "menu-about", path: "about" },
      { key: "menu-contact", path: "contact" },
    ],
  },
];

const socmeds = [
  {
    key: "Instagram",
    href: "https://www.instagram.com/childreamsstudio/",
    color: "#A7D169",
    icon: IconIG,
  },
  {
    key: "Youtube",
    href: "https://www.youtube.com",
    color: "#F38F8F",
    icon: IconYT,
  },
  {
    key: "Email",
    href: "mailto:halo@childreamsstudio.com",
    color: "#FCBD12",
    icon: IconEmail,
  },
];

const Footer = () => {
  const location = useLocation(); // Get the current location (URL)
  const { t } = useTranslation();

  const resolveLabel = (key) => (key.startsWith("book-") ? t(`${key}.title`) : t(key));

  return (
    <footer className="text-white">
      <div className="footer-divider" style={{ backgroundColor: "#272727" }}>
        <Container>
          <Row className="">
            <Col md={3} lg={4}>
              <Link to={getPath("home")}>
                <img src="/assets/logo-white.svg" alt="Childreams Logo" height={64} className="mb-3 logo-white" />
              </Link>
            </Col>
            <Col md={9} lg={8}>
              <Row>
                {links.map((link) => (
                  <Col xs={6} md={3} key={link.key}>
                    <h6 className="footer-heading subsection">{t(link.key)}</h6>
                    <ul className="list-unstyled footer-links">
                      {link.sublinks.map((sublink) => (
                        <li key={sublink.key}>
                          <Link to={getPath(sublink.path)} className={[location.pathname === getPath(sublink.path) ? "active-link" : "", sublink.disabled ? "disabled-nav" : ""].join(" ")}>
                            {resolveLabel(sublink.key)}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </Col>
                ))}
                <Col xs={6} md={3}>
                  <div className="social-icons">
                    {socmeds.map((socmed) => (
                      <Card key={socmed.key}>
                      <a
                        key={socmed.key}
                        href={socmed.href} // Add the actual URL here
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-icon"
                        style={{ backgroundColor: socmed.color }}
                      >
                        
                          <img src={socmed.icon} alt={socmed.key} />
                     
                      </a>
                         </Card>
                    ))}
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="text-center" style={{ padding: "8px", backgroundColor: "#505050", fontSize: "12px" }}>
        Copyright Childreams Studio {new Date().getFullYear()}. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
